import {GET_GL_ACCOUNTS, GET_GL_ACCOUNT_BY_ID} from '../../actions/actiontypes';
import initialstate from '../initialstate';
import {HttpStatusCodes} from '../../util/uiconstants';

export function glAccountReducer(state = initialstate.glAccounts, action) {
	switch (action.type) {
		case GET_GL_ACCOUNTS:
			if (action.response && action.responseObj.status === HttpStatusCodes.Ok) {
				return action.response;
			}
			return state;
		case GET_GL_ACCOUNT_BY_ID:
			if (action.response && action.responseObj.status === HttpStatusCodes.Ok) {
				return action.response;
			}
			return state;

		default:
			return state;
	}
}
